export default __webpack_public_path__ + "static/media/screen1.1eb48f7f.png";